module.exports = __webpack_public_path__ + "static/media/img-2.dbd78e3b.jpg";